// bootstrap.js

"use strict";

import angular from "angular";
import { AGENTES_SWENO_ENERGIA } from "../app";

angular.bootstrap(document, [AGENTES_SWENO_ENERGIA], {
  strictDi: true
});
